import { render, staticRenderFns } from "./Avatar.vue?vue&type=template&id=d3d22b40"
import script from "./Avatar.js?vue&type=script&lang=js&external"
export * from "./Avatar.js?vue&type=script&lang=js&external"
import style0 from "./Avatar.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports